import Vue from "vue";
import * as types from "./mutation-types";

const mutations = {
  [types.SET_CHALLENGE](state, data) {
    if (Vue._.isEmpty(state[data.key])) {
      // since "data.key" is not initialized in index.js,  "Vue.set" is used to create the reactiveGetter/Setter.
      Vue.set(state, data.key, data.value);
    } else {
      // note, not all challenge routes fetch the map relation
      // "_.assign" allows use to use this mutation for those which don't have the maps relation by "extending" the value
      // cloneDeep is needed for reactivity to propogate, which is otherwise trashed by "assign"
      let stateCopy = Vue._.cloneDeep(state[data.key]);
      state[data.key] = Vue._.assign(stateCopy, data.value);
    }
  },

  [types.DELETE_CHALLENGE](state, data) {
    delete state[data.key];
  },

  [types.SET_CHALLENGE_DISCUSSION](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_CHALLENGE_LEADERBOARD](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_CHALLENGE_AGGREGATE](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ALL_CHALLENGE_PACKAGES](state, packages) {
    state.allChallengePackages = packages;
  },

  [types.SET_CHALLENGE_PACKAGES_FOR_BUILDER](state, packages) {
    state.challengePackagesForBuilder = packages;
  },

  [types.SENT_CHALLENGE_INVITES](state, invites) {
    state.sentChallengeInvites = invites;
  },

  [types.SET_ALL_MEMBERS_INVITED](state, bool) {
    state.allMembersInvited = bool;
  },

  [types.SET_REFRESH_JOINED_STATUS_NEEDED](state, bool) {
    state.refreshJoinedStatusNeeded = bool;
  },

  [types.SET_MOBILE_CHALLENGE](state, challenge) {
    state.mobileChallenge = challenge;
  },

  [types.SET_CHALLENGE_MILESTONES](state, { challengeId, milestones }) {
    Vue.set(state.challengeMilestones, challengeId, milestones);
  },

  CLEAR_ALL_LEADERBOARDS(state) {
    Object.keys(state).forEach(key => {
      if (
        key.startsWith("leaderboard") ||
        key.startsWith("organizationLeaderboard")
      ) {
        state[key] = undefined;
      }
    });
    state.leaderboardLoaded = false;
  }
};

export default mutations;
